import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import partOfOurStoryLogo1 from '../../../../assets/logos/PartOfOurStoryLogo1.webp';
import partOfOurStoryLogo2 from '../../../../assets/logos/PartOfOurStoryLogo2.webp';
import partOfOurStoryLogo3 from '../../../../assets/logos/PartOfOurStoryLogo3.webp';

export const PartOfOurStorySection = () => {
  const history = useHistory();

  const handleSubmitPhotos = () => {
    history.push('/homeowner-portal/submit-photos');
  };

  const storyImages = [
    { src: partOfOurStoryLogo1, alt: 'Family moment 1' },
    { src: partOfOurStoryLogo2, alt: 'Family moment 2' },
    { src: partOfOurStoryLogo3, alt: 'Family moment 3' }
  ];

  return (
    <Box
      sx={{
        pt: 2,
        pb: 8,
        px: { xs: 2, md: 4 }
      }}
    >
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={7}>
          <Box
            sx={{
              borderRadius: '0px',
              height: { xs: '300px', md: '500px' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2.5,
              overflow: 'hidden'
            }}
          >
            {storyImages.map((image, index) => (
              <Box
                key={index}
                component="img"
                src={image.src}
                alt={image.alt}
                sx={{
                  flex: 1,
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '2px'
                }}
              />
            ))}
          </Box>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 900
              }}
            >
              Your Journey is Part of Our Story
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontStyle: 'italic',
                mb: 3
              }}
            >
              We'd love to see how you're living life in your Stone Martin home!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 3
              }}
            >
              Start by uploading your favorite photos — whether it's a cozy corner, a family moment,
              or your furry friend enjoying the backyard. Your experience helps tell the story of
              what makes our communities so special.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 3
              }}
            >
              Your photo might be featured in our campaigns, shared on our website, or highlighted
              on our social media.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: { xs: 2, md: 4 }
              }}
            >
              We can't wait to celebrate your story with the Stone Martin family!
            </Typography>

            <Button
              variant="contained"
              onClick={handleSubmitPhotos}
              fullWidth
              sx={{ mt: { xs: 1, md: 2 } }}
            >
              Submit your photos
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
